<template>
  <div
    id="app"
    v-if="visible"
  >
    <TopNews v-if="needTopNewsRoutes.indexOf($route.name) > -1"></TopNews>
    <TopMenu v-if="noNeedTopMenuRoutes.indexOf($route.name) == -1"></TopMenu>
    <router-view v-if="routerVisible" />
    <!-- 部分路由不应该包含这个Footer -->
    <Footer v-if="noNeedFooterRoutes.indexOf($route.name) == -1"></Footer>
  </div>
</template>

<script>
import TopNews from '@/components/news/TopNews';
import TopMenu from '@/components/header/TopMenu';
import Footer from '@/components/footer/Footer';
export default {
  name: 'App',
  provide () {
    return {
      reloadPage: this.reloadPage,
      reloadBody: this.reloadBody
    };
  },
  components: {
    TopNews,
    TopMenu,
    Footer
  },
  data () {
    return {
      visible: true,
      routerVisible: true,
      timerApp: '',
      timerRouter: '',
      needTopNewsRoutes: ['Index'],
      noNeedFooterRoutes: ['HomeIndex', 'MyAddress', 'AddAddress', 'MyOrder', 'MyShoppingCart'],
      noNeedTopMenuRoutes: ['AccountLogin', 'VerificationCodeLogin', 'PersonalUser', 'CompanyUser']
    };
  },
  methods: {
    reloadPage (timeout) {
      timeout = timeout || 500;
      this.timerApp = setTimeout(() => {
        this.visible = false;
        this.$nextTick(function () {
          this.visible = true;
          console.log('App view reload');
        });
      }, timeout);
    },
    reloadBody (timeout) {
      timeout = timeout || 500;
      this.timerRouter = setTimeout(() => {
        this.routerVisible = false;
        this.$nextTick(function () {
          this.routerVisible = true;
          console.log('Router view reload');
        });
      }, timeout);
    }
  },
  beforeDestroy () {
    if (this.timerApp) {
      clearInterval(this.timerApp);
    }
    if (this.timerRouter) {
      clearInterval(this.timerRouter);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue